import { AbstractApiModel } from '@ng-cloud/badger-core/models/abstract-api-model';

export class RfidScanEvent extends AbstractApiModel<RfidScanEvent> {
  tagCount: number;
  playExecutionId: number;
  scanEventDataId: number;
  scanZoneExecutionId: number;
  scanZoneId: number;
  startTime: Date;
  endTime: Date;

  deserialize(json: any): this {
    this.tagCount = json.tag_count;
    this.playExecutionId = json.play_execution_id;
    this.scanEventDataId = json.scan_event_data_id;
    this.scanZoneExecutionId = json.scan_zone_execution_id;
    this.scanZoneId = json.scan_zone_id;
    this.startTime = json.started_at;
    this.endTime = json.finished_at;
    return super.deserialize(json);
  }

}
